import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import { useAccountMutations } from "hooks/useAccountsTable";

const DeleteAccountModal = ({ account, open, onOpenChange }) => {
  const { remove } = useAccountMutations({
    onDeleted: () => onOpenChange(false),
  });

  const handleConfirm = () => remove.mutate(account.id);

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete account?"
      description={`Are you sure you want to delete ${account.email_address}?`}
      onConfirm={handleConfirm}
    />
  );
};

export default DeleteAccountModal;
